import { Field, Textarea } from '@chakra-ui/react'
import cn from 'clsx'
import { forwardRef } from 'react'

import Icon from '../icon/Icon'

interface ICustomTextareaProps {
	value: string
	onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void
	onBlur?: (e: React.FocusEvent<HTMLTextAreaElement>) => void
	iconName: string
	fieldLabel: string
	rootClassname?: string
	inputClassname?: string
	placeholder?: string
	error?: boolean
	onClear?: () => void
	maxLength?: number
}

const CustomTextarea = forwardRef<HTMLTextAreaElement, ICustomTextareaProps>(
	(
		{
			value,
			onChange,
			onBlur,
			iconName,
			fieldLabel,
			rootClassname,
			inputClassname,
			placeholder,
			error,
			onClear,
			maxLength
		},
		ref
	) => {
		const clearSearch = () => {
			onChange({
				target: { value: '' }
			} as React.ChangeEvent<HTMLTextAreaElement>)
			if (onClear) {
				onClear()
			}
		}
		return (
			<Field.Root className={rootClassname}>
				<div className='w-full relative flex flex-col'>
					<Field.Label className='mb-2'>{fieldLabel}</Field.Label>
					<Textarea
						ref={ref}
						value={value}
						onChange={onChange}
						onBlur={onBlur}
						className={cn(
							'peer w-full rounded-[8px] pl-4 pr-10 pt-3 border-2 bg-gray-100 focus:bg-white',
							error ? 'border-[#DE1135]' : 'border-gray-100 focus:border-black',
							value && 'has-value',
							inputClassname
						)}
						placeholder={placeholder}
						height={20}
						maxLength={maxLength || Infinity}
					/>
					{value && (
						<button
							type='button'
							className='absolute top-1/2 right-4'
							onClick={clearSearch}
						>
							<Icon size={24} icon={iconName} />
						</button>
					)}
				</div>
			</Field.Root>
		)
	}
)

export default CustomTextarea

// This styles we can use for floating label. Just import floatingStyles from ../input/FloatingStyles
// and add it to Field.Label
// css={floatingStyles} style={{ background: 'none' }}
